import { render, staticRenderFns } from "./voiceTable.vue?vue&type=template&id=619572ff&"
import script from "./voiceTable.vue?vue&type=script&lang=js&"
export * from "./voiceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports